import { Builder } from "@builder.io/react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import IsGTMScriptLoaded from "../../../../../utils/isGTMScriptLoaded";
import getSymbolFromCurrency from "currency-symbol-map";
import { selectSelectedCurrency } from "../../../../../store/user";
import services from "../../../../../services";
import FundraiserProductBox from "./FundraiserProductBox";
import { shouldTrackTikTokEvent } from "../../../../../utils/checkDomain";
import { selectProducts } from "../../../../../store/products";

const OrphanQuote = ({ quoteDescription,quoteTitle,quoteAuthor }) => {
  return (
    <div className="w-full flex flex-wrap justify-center md:container md:mx-auto px-4 py-4 md:py-8">
      <div className="basis-full flex flex-col justify-center mb-8 md:mb-16">
        <div className="w-full md:container flex justify-center">
          <div className="flex items-start mr-2 md:mr-4 w-[48px]">
            <svg className='rotate-180' data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 245 186.15">
              <path d="M242.5,87.53c-1.52,7.1-2.55,14.35-4.63,21.27-10.7,35.68-35.15,57.79-69.71,69.59-5,1.71-10.16,2.82-15.56,4.28l-9.89-21.3c24.63-11.76,37.24-31.54,40.19-58.79H142.83V2.5H242.5Z" transform="translate(0 0)" fill='none' stroke='#00a3da' strokeWidth={4} />
              <path d="M2.5,2.5h99.14c.39.75.67,1,.66,1.31-.22,28.16,1,56.43-1,84.46-3,41-25.34,69.46-62.62,86.09C30.52,178,21.75,180.14,13,183.08L2.5,161.56v-1a16.11,16.11,0,0,0,2.8-.76c18.55-8.7,29.5-23.71,35.12-42.94,1.31-4.48,1.63-9.25,2.48-14.32H2.5Z" transform="translate(0 0)" fill='none' stroke='#00a3da' strokeWidth={4} />
            </svg>
          </div>
          <div className="flex w-[80%] md:w-[60%] xl:w-[40%]">
            <p className="text-center text-lg md:text-4xl text-[#00a3da]">
              {quoteDescription}
              <span className="font-['Gotcha'] font-medium text-[#253b7e] md:text-5xl mx-2 md:mx-4">
                {quoteTitle}
              </span>
              <span className="font-['Abeezee'] text-[#253b7e] mx-2 md:mx-4 text-base md:text-lg">
                {quoteAuthor}
              </span>
            </p>
          </div>
          <div className="flex items-end ml-2 md:ml-4 w-12">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 245 186.15">
              <path d="M242.5,87.53c-1.52,7.1-2.55,14.35-4.63,21.27-10.7,35.68-35.15,57.79-69.71,69.59-5,1.71-10.16,2.82-15.56,4.28l-9.89-21.3c24.63-11.76,37.24-31.54,40.19-58.79H142.83V2.5H242.5Z" transform="translate(0 0)" fill='none' stroke='#00a3da' strokeWidth={4} />
              <path d="M2.5,2.5h99.14c.39.75.67,1,.66,1.31-.22,28.16,1,56.43-1,84.46-3,41-25.34,69.46-62.62,86.09C30.52,178,21.75,180.14,13,183.08L2.5,161.56v-1a16.11,16.11,0,0,0,2.8-.76c18.55-8.7,29.5-23.71,35.12-42.94,1.31-4.48,1.63-9.25,2.48-14.32H2.5Z" transform="translate(0 0)" fill='none' stroke='#00a3da' strokeWidth={4} />
            </svg>
          </div>
        </div>
      </div>
    </div>
  )

};
Builder.registerComponent(OrphanQuote, {
  name: "OrphanQuote",
  inputs: [
    {
      name: "quoteDescription",
      type: "string",
      required:true
    },
    {
      name:"quoteTitle",
      type:"string",
    },
    {
      name:"quoteAuthor",
      type:"string"
    }
  ]
});
export default OrphanQuote;
